define('../app/fukit/model/admin.base.model',['require','exports','module','lodash','../config','./base.model'],function(require, exports, module) {
  //prettier-ignore
  var lodash         = require('lodash'),
        Config         = require('../config'),
        BaseModel      = require('./base.model');

  var baseApiRUL = Config.get('admin.api.base.url');

  var AdminBaseModel = BaseModel.extend({
    baseUrlRoot: baseApiRUL ? baseApiRUL : '/api/v2',
  });

  module.exports = AdminBaseModel;
});

